import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsBar = ({ metrics }) => {
  const metricCards = [
    {
      label: 'Total Requests',
      value: metrics?.total,
      icon: 'Inbox',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Pending',
      value: metrics?.pending,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'In Progress',
      value: metrics?.inProgress,
      icon: 'Activity',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Completed Today',
      value: metrics?.completed,
      icon: 'CheckCircle2',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {metricCards?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4 shadow-elevation-1">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1">{metric?.label}</p>
              <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
            </div>
            <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${metric?.bgColor}`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} strokeWidth={2} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsBar;